import { useEffect, useState } from "react";
import DivStyle from "../../components/style/div.component";
import Page from "../../components/table/paging";
import { FormProps } from "../../components/form/interface/formInterface";
import InputFormStyle from "../../components/style/input_form.component";
import Icon from "@mdi/react";
import { mdiMagnify } from "@mdi/js";
import SmallForm from "../../components/form/small_form";
import { SolutionAdVideoDto } from "./interface/interface";
import AdminAPI from "../../api/admin";
import ButtonStyle from "../../components/style/button.component";
import AdTable from "../../components/table/AdTable";
import { AdVideoType } from "../../api/admin/solution-ad-video";
import { DateRange } from "../../components/form/form_date_list";

const TABS: { type: AdVideoType; label: string }[] = [
  { type: "PUB", label: "펍" },
  { type: "TOURNAMENT", label: "토너먼트" },
];

const TournamentAdVideo = () => {
  const [activeType, setActiveType] = useState<AdVideoType>("PUB");
  const [list, setList] = useState<SolutionAdVideoDto[]>([]);
  const [searchList, setSearchList] = useState<SolutionAdVideoDto[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [mode, setMode] = useState("V");

  const [id, setId] = useState(0);
  const [fileName, setFileName] = useState("");
  const [order, setOrder] = useState(0);
  const [dates, setDates] = useState<DateRange[]>([]);

  const formData: FormProps = {
    title: "상세정보",
    form: [
      {
        value: fileName,
        setValue: setFileName,
        label: "파일명",
        type: "input",
        width: "100%",
      },
      {
        value: mode === "I" ? list.length + 1 : order,
        setValue: setOrder,
        label: "순서",
        type: "input-dash",
        width: "100%",
      },
      {
        value: dates,
        setValue: setDates,
        label: "기간 설정",
        type: "date-list",
        width: "100%",
      },
    ],
  };

  const headers = [
    {
      text: "순번",
      align: "center",
      sortable: false,
      value: "order",
    },
    {
      text: "파일명",
      align: "start",
      sortable: false,
      value: "fileName",
    },
    {
      text: "타입",
      align: "center",
      sortable: false,
      value: "type",
    },
  ];

  const resetForm = () => {
    setMode("V");
    setId(0);
    setFileName("");
    setOrder(0);
    setDates([]);
  };

  const setDetail = async (item: SolutionAdVideoDto) => {
    setMode("U");
    setId(item.id);
    setFileName(item.fileName);
    setOrder(item.order);
    setDates(item.dates || []);
  };

  const addForm = () => {
    setMode("I");
    setId(0);
    setFileName("");
    setOrder(list.length + 1);
  };

  const save = async () => {
    if (!fileName.trim()) {
      alert("파일명을 입력해주세요.");
      return;
    }

    if (window.confirm("저장 하시겠습니까?")) {
      try {
        await AdminAPI.updateSolutionAdVideo(id, {
          type: activeType,
          fileName: fileName.trim(),
          order: Number(order),
          dates,
        });
        alert("저장되었습니다.");
        resetForm();
        getList();
      } catch (e: any) {
        alert(e.message);
      }
    }
  };

  const remove = async () => {
    if (window.confirm("삭제 하시겠습니까?")) {
      try {
        await AdminAPI.deleteSolutionAdVideo(id);
        alert("삭제 되었습니다.");
        getList();
        resetForm();
      } catch (e: any) {
        alert(e.message);
      }
    }
  };

  const add = async () => {
    if (!fileName.trim()) {
      alert("파일명을 입력해주세요.");
      return;
    }

    const nextOrder = list.length + 1;

    if (window.confirm("신규 등록 하시겠습니까?")) {
      try {
        await AdminAPI.createSolutionAdVideo({
          type: activeType,
          fileName: fileName.trim(),
          order: nextOrder,
          dates,
        });
        alert("신규 등록이 되었습니다.");
        getList();
        resetForm();
      } catch (e: any) {
        alert(e.message);
      }
    }
  };

  const handleSearch = (search: string) => {
    setCurrentPage(1);

    if (!search.trim()) {
      setSearchList(list);
      setTotalPages(Math.ceil(list.length / 10));
      return;
    }

    const filteredList = list.filter((item: SolutionAdVideoDto) => {
      return Object.values(item).some((value) => {
        if (!value) return false;
        return value.toString().toLowerCase().includes(search.toLowerCase());
      });
    });

    setSearchList(filteredList);
    setTotalPages(Math.ceil(filteredList.length / 10));
  };

  const getList = async () => {
    const res = await AdminAPI.getSolutionAdVideoList(activeType);
    if (res && res.status === 200) {
      const data: SolutionAdVideoDto[] = res.data ?? [];
      setTotalPages(Math.ceil(data.length / 10));
      setList(data);
      setSearchList(data);
    }
  };

  const handleSetDataList = (items: SolutionAdVideoDto[]) => {
    setSearchList(items);
    setList(items);
  };

  const handleDragSort = async (items: { id: number; order: number }[]) => {
    try {
      await AdminAPI.updateSolutionAdVideoOrder(items);
    } catch (e: any) {
      alert(e.message || "순서 변경에 실패했습니다.");
      getList();
    }
  };

  const changeTab = (type: AdVideoType) => {
    setActiveType(type);
    setCurrentPage(1);
    resetForm();
    setDates([]);
  };

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeType]);

  return (
    <DivStyle
      style={{ overflow: "auto" }}
      backgroundColor="#121212"
      height="100vh"
      display="flex"
      flex_direction="row"
      marginTop="65px"
      setMobile={true}
    >
      <DivStyle
        width="66%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="flex-end"
      >
        <DivStyle
          width="100%"
          height="auto"
          display="flex"
          flex_direction="column"
          align_items="center"
          setMobileTable={true}
        >
          <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>
            셀러 광고 관리
          </h2>
          <DivStyle
            width="95%"
            display="flex"
            backgroundColor="#1E1E1E"
            flex_direction="column"
            borderRadius="10px"
            marginTop="30px"
            marginBottom="20px"
          >
            <DivStyle
              width="100%"
              display="flex"
              flex_direction="row"
              justify_content="space-between"
              align_items="center"
              style={{ padding: "20px 20px 0 20px", boxSizing: "border-box" }}
            >
              <DivStyle display="flex" flex_direction="row" style={{ gap: 8 }}>
                {TABS.map((tab) => (
                  <ButtonStyle
                    key={tab.type}
                    border="none"
                    backgroundColor={
                      activeType === tab.type ? "#1976D2" : "#333"
                    }
                    width="100px"
                    height="36px"
                    color="white"
                    borderRadius="5px"
                    onClick={() => changeTab(tab.type)}
                  >
                    {tab.label}
                  </ButtonStyle>
                ))}
              </DivStyle>
              <DivStyle
                width="40%"
                display="flex"
                justify_content="flex-end"
                flex_direction="row"
                align_items="center"
              >
                <InputFormStyle
                  onChange={(e) => handleSearch(e.target.value)}
                ></InputFormStyle>
                <Icon path={mdiMagnify} size={1} style={{ color: "white" }} />
              </DivStyle>
            </DivStyle>

            <AdTable
              headers={headers}
              currentPage={currentPage}
              dataList={searchList}
              setDetail={setDetail}
              setDataList={handleSetDataList}
              onDragSort={handleDragSort}
              orderField="order"
            />
            <Page
              currentPage={currentPage}
              totalPages={totalPages}
              dataList={searchList}
              setCurrentPage={setCurrentPage}
            />
          </DivStyle>
        </DivStyle>
        <ButtonStyle
          border="none"
          backgroundColor="#1976D2"
          width="85px"
          height="40px"
          color="white"
          borderRadius="5px"
          marginRight="25px"
          onClick={() => addForm()}
        >
          신규 등록
        </ButtonStyle>
      </DivStyle>
      <DivStyle
        width="33%"
        height="auto"
        display="flex"
        flex_direction="column"
        align_items="center"
        setMobileForm={true}
      >
        <h2 style={{ color: "white", width: "auto", marginTop: "40px" }}>폼</h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <SmallForm
            form={formData.form}
            title={formData.title}
            save={save}
            add={add}
            mode={mode}
            remove={remove}
          />
        </DivStyle>
      </DivStyle>
    </DivStyle>
  );
};

export default TournamentAdVideo;
